import Report from './_Report';

export default Report;
